import { useMemo } from "react";

import { CountryDropdownItem, Dropdown, CountryDropdownButton } from "@similarweb/ui-components";

import * as SC from "./styles";
import type { CountryDropdownSchema } from "./types";

// Reusable single select country dropdown
export const CountryDropdown = ({
    onClick,
    selectedCountryId,
    countries,
    buttonWidth,
    dropdownPopupMinScrollHeight,
    scrollAreaMinHeight,
    dropdownPopupHeight,
    appendTo,
    isDisabled = false,
    hasSearch,
    placement = "ontop-left",
}: CountryDropdownSchema) => {
    const selectedCountryName = useMemo(
        () => countries.find((item) => item.id === selectedCountryId)?.text,
        [countries, selectedCountryId],
    );

    return (
        <Dropdown
            appendTo={appendTo ? appendTo : null}
            selectedIds={{ [selectedCountryId]: true }}
            shouldScrollToSelected={true}
            onClick={onClick}
            itemsComponent={CountryDropdownItem}
            buttonWidth={buttonWidth}
            dropdownPopupMinScrollHeight={dropdownPopupMinScrollHeight}
            scrollAreaMinHeight={scrollAreaMinHeight}
            dropdownPopupHeight={dropdownPopupHeight}
            dropdownPopupPlacement={placement}
            disabled={isDisabled}
            hasSearch={hasSearch}
        >
            {[
                <CountryDropdownButton
                    key="settings-country-btn"
                    countryId={selectedCountryId}
                    disabled={isDisabled}
                >
                    <SC.Text isDisabled={isDisabled}>{selectedCountryName}</SC.Text>
                </CountryDropdownButton>,
                ...countries,
            ]}
        </Dropdown>
    );
};
